export const platformAdminCommon = {
  open: "打开",
  openPortal: "打开门户",
  openExamAdmin: "打开考试后台",
  consolePage: "进入",
  modulePage: "进入模块",
  detail: "查看",
  phase: "阶段",
  endpoint: "端点",
  statusCodeLatency: "状态码 {status} · 延迟 {latency} ms",
  probeStatusCode: "探针状态码",
  probeLatency: "探针延迟",
  checkedAt: "最近检查时间",
  latestError: "最近错误",
  latestCheckSuccess: "最近检查未发现错误。",
  probeErrors: {
    urlUnavailable: "健康检查地址不可用",
    httpError: "探针返回 HTTP {status}",
    timeout: "探针请求超时（{timeout_ms} ms）",
    requestAborted: "探针请求已中止",
    networkUnreachable: "探针无法连通目标服务",
    requestFailed: "探针请求失败",
  },
  planning: "规划中",
  pageNotFound: "页面不存在。",
  backToAdmin: "返回平台后台",
  domainLabel: "域名：{value}",
  latencyLabel: "延迟：{value}",
} as const;
